import { UIText2 } from '@cian/ui-kit';
import { ISVGIconProps } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';
import styles from './UndergroundItem.css';

interface IUndergroundItemProps {
  icon: FC<ISVGIconProps>;
  iconColor: string;
  name: string;
  travelTypeIcon: FC<ISVGIconProps>;
  travelTime?: string;
}

export const UndergroundItem: FC<IUndergroundItemProps> = ({
  icon: Icon,
  iconColor,
  name,
  travelTypeIcon: TravelTypeIcon,
  travelTime,
}) => {
  return (
    <div className={styles['underground-item']}>
      <div style={{ color: iconColor }} className={styles['icon']}>
        <Icon color="current_color" />
      </div>
      <UIText2>{name}</UIText2>
      {travelTime && (
        <div className={styles['travel-info']}>
          <TravelTypeIcon color="gray60_100" />
          <UIText2 color="gray60_100">{travelTime}</UIText2>
        </div>
      )}
    </div>
  );
};
